export const MASLogo = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    aria-label="MAS Arts Studio logo"
  >
    <rect width="64" height="64" rx="18" fill="#1d1d1b" />
    <path
      d="M14 46 L32 14 L50 46"
      fill="none"
      stroke="#eae4da"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="32" cy="40" r="5" fill="#eae4da" />
    <path d="M22 46 h20" stroke="#eae4da" strokeWidth="4" strokeLinecap="round" />
  </svg>
);
